import { isKeyHotkey } from 'is-hotkey';

export interface KeyboardEventLike {
	key: string;
	which: number;
	altKey: boolean;
	ctrlKey: boolean;
	metaKey: boolean;
	shiftKey: boolean;
	preventDefault(): void;
}

export const onTabPress = (evt: KeyboardEventLike, callback: () => void) => {
	if (isKeyHotkey('tab', evt)) {
		evt.preventDefault();
		callback();
	}
};

export const preventScrollWithArrowKey = (evt: KeyboardEvent) => {
	if (isKeyHotkey(['arrowup', 'arrowright', 'arrowdown', 'arrowleft'], evt)) {
		evt.preventDefault();
	}
};

export const onEnterOrSpace =
	<T>(callback: (evt: T) => void) =>
	(evt: KeyboardEventLike) => {
		if (isKeyHotkey('enter', evt) || isKeyHotkey('space', evt)) {
			evt.preventDefault();
			callback(evt as T);
		}
	};

export const stopPropagation = (evt: KeyboardEvent): boolean => {
	const ae = document.activeElement;
	const editableActiveElement = ae
		? ae.nodeName.toLowerCase() === 'input' ||
			ae.nodeName.toLowerCase() === 'textarea' ||
			ae.getAttribute('contenteditable') === 'true'
		: false;

	if (editableActiveElement) return false;

	evt.stopPropagation();
	return true;
};
